module.exports = __webpack_public_path__ + "img/logistics.c8b3cbb3.png";